import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientAlert } from '@ffd/api-client';
import { PatientAlertsItemDetailsComponent } from '../patient-alerts-item-details/patient-alerts-item-details.component';
import { PatientAlertsItemEditComponent, PatientAlertsItemSaveData } from '../patient-alerts-item-edit/patient-alerts-item-edit.component';

@Component({
  selector: 'lib-patient-alerts-item',
  standalone: true,
  imports: [CommonModule, PatientAlertsItemDetailsComponent, PatientAlertsItemEditComponent],
  templateUrl: './patient-alerts-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientAlertsItemComponent {
  public readonly patientAlertsItem = input.required<PatientAlert>();
  public readonly isEditMode = input.required<boolean>();
  public readonly isNewItem = input.required<boolean>();
  public readonly isLoading = input.required<boolean>();
  public readonly editPatientAlertEnabled = input<boolean>(true);
  public readonly deletePatientAlertEnabled = input<boolean>(true);

  public changeEditMode = output<{ editMode: boolean; itemId: number }>();
  public deleteItem = output<number>();
  public saveItem = output<PatientAlertsItemSaveData>();
  public discardNewItem = output<void>();

  public setEditMode(editMode: boolean): void {
    this.changeEditMode.emit({ editMode, itemId: this.patientAlertsItem().id });
  }

  public onDeleteItem(event: number): void {
    this.deleteItem.emit(event);
  }

  public onSaveItem(event: PatientAlertsItemSaveData): void {
    this.saveItem.emit(event);
  }

  public onDiscardNewItem(): void {
    this.discardNewItem.emit();
  }
}
